import React from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { Grid, Link, Typography } from '@mui/material'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'

const TimeBlock = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
    <DetailRow label={label} value={value && moment(value).format('HH:mm')} />
  </Grid>
)
const IncidentModule = ({ record }) => {
  return (
      <DetailsBox
        title="Incident Details"
        rows={[
          {
            label: 'Incident Date',
            value: moment(record.incidentDate).format('Do MMM YYYY HH:mm'),
          },
          {
            label: 'Linked Event',
            value: record?.event ? (
              <Link href={`/events/${record?.event?._id}`} target="_blank">
                {record.event.title}
              </Link>
            ) : (
              'None'
            ),
          },
          { label: 'Incident Type', value: record.incident.incidentType },
          { label: 'Presenting Complaint', value: record.incident.presentingComplaint?.join(', ') },
          { label: 'Patient Outcome', value: record.plan.ptOutcome}
        ]}
      >
        <DetailRow
          label="Staff Involved"
          value={
            record?.staffInvolved?.length > 0
              ? record.staffInvolved
                  .map(
                    (x) =>
                      x.userAccount.firstName +
                      ' ' +
                      x.userAccount.lastName +
                      ' (' +
                      x.clinicalRole +
                      ')'
                  )
                  .join(', ')
              : 'None'
          }
        />
      </DetailsBox>
  )
}

export default IncidentModule
